import { Decoder, number, object, string } from '@mojotech/json-type-validation'

import { JudgeReview } from '@/domain/entities/modelAnswer/judgeReview'
import { policyTypeDecoder } from '@/infrastructure/decoders/config/policyTypeDecoder'
import { programLanguageTypeDecoder } from '@/infrastructure/decoders/language/programLanguageTypeDecoder'

export const judgeReviewDecoder: Decoder<JudgeReview> = object({
  judgeId: number(),
  userId: string(),
  problemId: string(),
  language: programLanguageTypeDecoder,
  cpuTime: number(),
  memory: number(),
  submissionDate: number().map(x => new Date(x)),
  policy: policyTypeDecoder,
  sourceCode: string(),
  reviewed: number()
}).map(x => ({ ...x, programLanguage: x.language }))
